/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "./data-table-column-header";
import { Badge } from "@/components/ui/badge";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { IRecordsCashBalance } from "@/@types/cash-balance";
import capitalizeFirstLetter from "@/utils/capitalize-first-letter";

export const columns: ColumnDef<IRecordsCashBalance>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
  },
  {
    accessorKey: "store_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Loja" />
    ),
    cell: ({ row }) => `Loja ${row.original.store_id}`,
  },
  {
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const statusValue = row.original.type;

      const badgeStyles: Record<string, string> = {
        SOLICITADO: "bg-gray-100 text-gray-900",
        REPROCESSADO: "bg-[#F5CB2B] text-black",
      };

      return (
        <Badge
          className={`${badgeStyles[statusValue] || "bg-gray-300 text-black"
            } cursor-default`}
        >
          {statusValue}
        </Badge>
      );
    },
  },

  {
    accessorKey: "regional_email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Regional" />
    ),
    cell: ({ row }) => `${row.original.regional_email.replace("@grupoavenida.com.br", "")
      .split(".")
      .map(word => capitalizeFirstLetter(word))
      .join(" ")}`,
  },
  {
    accessorKey: "regional_email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email do Regional" />
    ),
  },
  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Solicitado em" />
    ),
    cell: ({ row }) => {
      const dateString = row.getValue("created_at") as string;

      if (!dateString) return "Sem Data";

      try {
        const parsedDate = parseISO(dateString);

        return format(parsedDate, "dd/MM/yyyy HH:mm:ss", { locale: ptBR });
      } catch (error) {
        return "Data Inválida";
      }
    },
  },
];
